import SyncfusionGrid from "components/custom/Syncfusion/SyncfusionGrid"
import React from "react"

const FormFieldTable = ({ formFields, editFormField, updateFormFields }) => {
  const deleteFormField = formField => {
    let copy = [...formFields]
    let existingFormField = copy.find(
      x => x.formFieldId == formField.formFieldId
    )
    copy.splice(copy.indexOf(existingFormField), 1)
    updateFormFields(copy)
  }

  const columns = [
    {
      headerText: "Field Label",
      field: "formFieldLabel",
      headerSort: false,
      template: data => (
        <a
          href="#"
          onClick={e => {
            e.preventDefault()
            editFormField(data)
          }}
        >
          {data.formFieldLabel}
        </a>
      ),
    },
    {
      headerText: "Type",
      field: "formFieldType.type",
    },
    {
      headerText: "Order",
      field: "orderId",
    },
    {
      headerText: "",
      field: "",
      width: 50,
      template: data => (
        <i
          className="fas fa-trash-alt"
          style={{ color: "red" }}
          onClick={() => deleteFormField(data)}
        ></i>
      ),
    },
  ]

  const onRowDrop = args => {
    let reorderedData = [...formFields]
    const [movedRow] = reorderedData.splice(args.fromIndex, 1)
    reorderedData.splice(args.dropIndex, 0, movedRow)

    reorderedData = reorderedData.map((item, index) => {
      return {
        ...item,
        orderId: index + 1,
      }
    })
    updateFormFields(reorderedData)
  }

  return (
    <>
      {formFields.length > 0 && (
        <SyncfusionGrid
          columns={columns}
          data={formFields}
          allowRowDragAndDrop={true}
          onRowDrop={onRowDrop}
          sortSettings={{
            columns: [{ field: "orderId", direction: "Ascending" }],
          }}
        />
      
      )}
    </>
  )
}

export default FormFieldTable
